import { useCallback, useEffect } from 'react'

import { useServices } from '@percent/partner-dashboard/context/serviceContext/ServiceContext'
import { useQuery, useRequiredParams } from '@percent/partner-dashboard/common/hooks'
import { useCandidateDetailsQueryParams } from './useCandidateDetailsQueryParams'

const MAX_PAGE_SIZE = 100

export function useCandidateTasks() {
  const { id: programId, candidateId } = useRequiredParams()
  const [queryParams, setQueryParams] = useCandidateDetailsQueryParams()
  const { grantsService } = useServices()

  const [{ data: myTasks, isLoading: isLoadingTasks }, { refresh }] = useQuery(grantsService.getMyTasksV2, {
    pageSize: MAX_PAGE_SIZE,
    programId,
    candidateId,
    withForm: true,
    status: 'todo'
  })

  const hasTasks = myTasks?.length > 0

  const closeTasksView = useCallback(() => {
    setQueryParams({ tasksView: undefined, formId: undefined })
  }, [setQueryParams])

  const openTasksView = () => {
    if (hasTasks) {
      setQueryParams({
        tasksView: 'true',
        comments: undefined,
        // Automatically open the first task if there is only one
        formId: myTasks.length > 1 ? undefined : myTasks[0].form?.formId
      })
    }
  }

  useEffect(() => {
    if (!isLoadingTasks && !hasTasks) {
      closeTasksView()
    }
  }, [hasTasks, closeTasksView, isLoadingTasks])

  return {
    tasks: myTasks,
    isTasksViewOpen: hasTasks && queryParams.tasksView === 'true',
    closeTasksView,
    openTasksView,
    refreshTasks: refresh,
    hasTasks
  }
}
